<template>
    <BaseGuidelineText
        v-if="summary"
        :content="summary.summaryOfChanges"
    />

    <div v-else>
        <h2>Not found</h2>
        <p>Sorry, we couldn't find any summary of change records for the requested guideline and/or year.</p>
    </div>
</template>

<script setup>
const { activeSite } = useMultisite();

const props = defineProps({
    guideline: {
        required: true,
        type: Object,
        default: null
    },
    summaries: {
        required: true,
        type: Array,
        default: null
    }
});


useEtherSeo(props.guideline, {}, activeSite);

const route = useRoute();

const summary = computed(() => {
    if (route.params.year) {
        return props.summaries?.find(summaryItem => summaryItem.changeYear === Number(route.params.year));
    } else {
        return props.summaries?.[0];
    }
});
</script>
